import { Type } from 'class-transformer';
import { WFVendorContractRawDto } from '../../../vendor-management/shared-vendor-management-module/_models/wf-vendor-contract-raw-dto';

export class WfeVendorContractParametersDto {
    workflowId: number;
    communityId: number;

    @Type(() => WFVendorContractRawDto)
    vendorContracts: Array<WFVendorContractRawDto>;
}
